@if (loaded) {
  <section class="page-wrapper scroll-container">
    <p class="page-title">
      You do not have permissions to access this screen. Please contact our
      <a href="https://www.connectpayusa.com/help">helpdesk</a> for further assistance.
    </p>
    <button class="btn btn-primary" (click)="logOut()">Log Out</button>
  </section>
} @else {
  <div class="centered d-flex flex-column w-100 text-center">
    <div>
      <img src="assets/images/R_Against_Dashed_Line.gif" />
    </div>
    <h3 class="text-cp-green fw-bold fst-italic">DON'T WORRY. THE PORTAL IS STILL RUNNING...</h3>
  </div>
}
